(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Markup', Markup);

    Markup.$inject = ['$resource'];

    function Markup ($resource) {
        var resourceUrl =  'api/markup-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/markup-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/markup-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/markup-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/markup-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'getAllMarkupForBranch': {
                  method: 'GET',
                  isArray: true,
                  params: {branchId:'@branchId',bankId:'@bankId'},
                  url: 'api/markup-for-branch/branch/:branchId/bank/:bankId',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },
              'getAllMarkupForCustomer': {
                  method: 'GET',
                  isArray: true,
                  params: {branchId:'@branchId',bankId:'@bankId'},
                  url: 'api/markup-for-customer/customer/:customerId',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              },
              
            'getAllMarkupForCustomerAndCurrencyPair': {
                  method: 'GET',
                  isArray: true,
                  params: {customerId:'@customerId',currencyPairCode:'@currencyPairCode'},
                  url: 'api/markup-for-customer/customer/:customerId/currencyPairCode/:currencyPairCode',
                  transformResponse: function (data) {
                      if (data) {
                          data = angular.fromJson(data);
                      }
                      return data;
                  }
              }
        });
    }
})();
